module.exports = __webpack_public_path__ + "img/qcrl.0829e338.png";